import { useFormik } from 'formik';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import InputBox from 'src/components/Common/InputBox/InputBox';
import * as Yup from 'yup';
import { validation } from 'src/constants/general';
import { toaster } from 'src/utils/toaster';
import { createTask, taskUpdate } from 'src/services/Task';
import ResponsiveTextWithIconButton from 'src/components/Responsive/ResponsiveTextWithIconButton';
import rightIcon from 'src/assets/svgs/rightIcon.svg';
import IconWithButton from 'src/components/Common/IconWithButton';
import { dateTimeFormate, getRemovetzTime, tokenDecode, utcConverter } from 'src/utils/function';
import calenderIcon from 'src/assets/svgs/calenderIcon.svg';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import closeIcon from 'src/assets/img/closeImg.png';
import { Dropdown } from 'primereact/dropdown';
import { userList } from 'src/services/additional';
import AsyncSelect from 'react-select/async';
import westImg from 'src/assets/img/westImg.png';
import logImg from 'src/assets/img/logImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import { employeeList } from 'src/services/employee';

const AddNewTask = ({ setIsSave, isSave, isOnSuccess, setBtnDisabled, btnDisabled, isUpdate, selectedRowData }: any) => {
    const [error, setError] = useState('');

    const [isSaveValidation, setIsSaveValidation] = useState(false);
    const [calenderOpen, setCalenderOpen] = useState({ start: false, end: false, payment: false });
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [dateError, setDateError] = useState<string>('');
    const foramteNewDate = (isDate: any) => new Date(getRemovetzTime(isDate, 'YYYY-MM-DD HH:mm:ss'));
    const [userListData, setuserListData] = useState<any>([]);
    const [selectedEmployeeOption, setSelectedEmployeeOption] = useState<any>([]);
    const [employeeListData, setEmployeeListData] = useState<any>([]);
    const [selectedAssignedToOption, setSelectedAssignedToOption] = useState<any>([]);
    // const [selectedEmployee, setSelectedEmployee] = useState<any>(null);

    const controller = new AbortController();
    const [userData, setUserData] = useState<any>({});
    const getToken = async () => {
        const token = await tokenDecode();
        setUserData(token);
    };
    useEffect(() => {
        getToken();
    }, []);

    const statusOptions = [
        { name: 'Pendding', value: 'pendding' },
        { name: 'In Progress', value: 'inProgress' },
        { name: 'Ready', value: 'ready' },
        { name: 'Completed', value: 'completed' },
    ];

    useEffect(() => {
        if (isSave) {
            formik.handleSubmit();
            setIsSave(false);
            setIsSaveValidation(true);
        }
    }, [isSave]);
    useEffect(() => {
        if (isUpdate && selectedRowData.id) {
            setStartDate(selectedRowData.startDate ? foramteNewDate(selectedRowData.startDate) : null);
            setEndDate(selectedRowData.endDate ? foramteNewDate(selectedRowData.endDate) : null);
        }
    }, [isUpdate, selectedRowData?.id]);
    useEffect(() => {
        getRoleList(controller.signal);

        return () => controller.abort();
    }, []);
    const handleEmployeeSelect = (selectedOption: any) => {
        const selected = Array.isArray(selectedOption) ? selectedOption : [];
        const selectedEmployeeIds = selected.map((opt: any) => opt.value);

        formik.setFieldValue('employeeId', selectedEmployeeIds);
        setError('');
        setSelectedEmployeeOption(selected);

        // const employees = selectedOption?.employeesData || [];
        // const employee = employees.find((emp: any) => emp.employeeId === selectedEmployeeIds[0]);
        // setSelectedEmployee(employee || null);
    };
    const getEmployList = useCallback(async (inputValue: string) => {
        try {
            const url = `?page=0&limit=20&search=${inputValue}`;
            const res = await employeeList(url);
            const employees = res?.data?.data?.employees || [];
            setEmployeeListData(employees);
            const options = [
                {
                    label: (
                        <div className="flex gap-6 font-semibold text-gray-600 text-sm border-b pb-1">
                            <span className="min-w-20">Company</span>
                            <span>Job Type</span>
                            <span>Employee Name</span>
                        </div>
                    ),
                    value: '__header__',
                    isDisabled: true,
                },
                ...employees.map((emp: any) => ({
                    label: (
                        <div className="flex gap-6">
                            <div className="flex gap-2 min-w-20">
                                <img
                                    src={emp.companyName === 'West' ? westImg : emp.companyName === 'Log' ? logImg : emp.companyName === 'Liani' ? lianiImg : fsImg}
                                    className="w-5 h-5"
                                    alt={emp.companyName}
                                />
                                <span>{emp.companyName}</span>
                            </div>
                            <span>{emp.jobType}</span>
                            <span>
                                {emp.name} {emp.surname}
                            </span>
                        </div>
                    ),
                    value: emp.employeeId,
                    employeesData: employees,
                })),
            ];
            return options;
        } catch (err) {
            return [];
        }
    }, []);

    const getSelectBoxOptions = (data: Array<any>, value: string = 'name', label: string = 'name') => {
        if (!Array.isArray(data)) {
            data = [data];
        }
        return data.map((res) => ({
            name: res[label],
            value: res[value],
        }));
    };
    const getRoleList = async (signal?: any) => {
        try {
            const roleResData = await userList();
            const data = roleResData?.data?.data;

            const assignedToOptions = getSelectBoxOptions(data.users || [], 'id', 'name');
            setuserListData(assignedToOptions);
        } catch (err) {}
    };

    const getUserList = useCallback(async (inputValue: string) => {
        try {
            const url = `?&search=${inputValue}`;
            const res = await userList(url);
            const users = res?.data?.data?.users || [];
            const options = users.map((user: any) => ({
                label: user.name,
                value: user.id,
            }));
            return options;
        } catch (err) {
            return [];
        }
    }, []);

    const handleAssignedToSelect = (selectedOption: any) => {
        const selected = Array.isArray(selectedOption) ? selectedOption : [];
        const selectedUserIds = selected.map((opt: any) => opt.value);
        formik.setFieldValue('assignedTo', selectedUserIds);
        setError('');
        setSelectedAssignedToOption(selected);
    };
    const makeTimeFormate = (formateTime: any, formateDate: any) => {
        const formattedTime = moment(formateTime, 'HH:mm').format('hh:mma');
        const newDate = moment(formateDate, 'ddd MMM DD YYYY HH:mm:ss ZZ').format('YYYY-MM-DD');
        const originalDateTime = `${newDate} ${formattedTime}`;
        const formattedDate = moment(originalDateTime, 'YYYY-MM-DD hh:mma').format('YYYY-MM-DD HH:mm:ss');
        return formattedDate;
    };
    const handleDateChange = useCallback(
        (date: Date, type: 'start' | 'end') => {
            if (type === 'start') {
                setStartDate(date);

                const finalDate = makeTimeFormate('00:00', date);
                formik.setFieldValue('startDate', finalDate);

                if (endDate && moment(date).isAfter(endDate, 'day')) {
                    setDateError('Start date cannot be after end date');
                    setEndDate(null);
                    formik.setFieldValue('endDate', '');
                } else {
                    setDateError('');
                }
            } else {
                setEndDate(date);

                const finalDate = makeTimeFormate('00:00', date);
                formik.setFieldValue('endDate', finalDate);

                if (startDate && moment(date).isBefore(startDate, 'day')) {
                    setDateError('End date cannot be before start date');
                } else {
                    setDateError('');
                }
            }
        },
        [startDate, endDate],
    );
    const parseEmployeeIds = (ids: any) => {
        if (Array.isArray(ids)) return ids;
        if (!ids) return [];

        if (typeof ids === 'string') {
            try {
                const parsed = JSON.parse(ids);
                if (Array.isArray(parsed)) return parsed;
            } catch {
                // fallback comma-separated format
                return ids
                    .replace(/\[|\]|\s+/g, '')
                    .split(',')
                    .filter(Boolean);
            }
        }

        return [];
    };

    const parseAssignedToIds = (ids: any) => {
        if (Array.isArray(ids)) return ids;
        if (!ids) return [];

        if (typeof ids === 'string') {
            try {
                const parsed = JSON.parse(ids);
                if (Array.isArray(parsed)) return parsed;
            } catch {
                return ids
                    .replace(/\[|\]|\s+/g, '')
                    .split(',')
                    .filter(Boolean);
            }
        }

        return [];
    };

    const getInitialValues = useCallback(() => {
        if (isUpdate && selectedRowData) {
            return {
                title: selectedRowData.title || '',
                description: selectedRowData.description || null,
                startDate: selectedRowData.startDate,
                endDate: selectedRowData.endDate,
                assignedTo: parseAssignedToIds(selectedRowData.assignedTo),
                status: selectedRowData.status || 'pendding',
                employeeId: parseEmployeeIds(selectedRowData.empIds),
                selectedItems: selectedRowData.selectedItems || [],
            };
        }

        return {
            title: '',
            description: null,
            startDate: '',
            endDate: '',
            assignedTo: [],
            status: 'pendding',
            employeeId: [],
            selectedItems: [],
        };
    }, [isUpdate, selectedRowData]);
    const CustomStartInput = forwardRef<HTMLDivElement>((props, ref) => (
        <div ref={ref} className="sidebar_date">
            <IconWithButton
                isMoreClass={`!w-full !justify-start`}
                title={startDate ? dateTimeFormate(startDate, 'DD MMM, YYYY') : 'Start Date'}
                icon={calenderIcon}
                onclick={() => setCalenderOpen((prev) => ({ ...prev, start: true }))}
                isDisabled={userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_create') ? false : true}
            />
        </div>
    ));
    const CustomEndInput = forwardRef<HTMLDivElement>((props, ref) => (
        <div ref={ref} className="sidebar_date">
            <IconWithButton
                title={endDate ? dateTimeFormate(endDate, 'DD MMM, YYYY') : 'End Date'}
                icon={calenderIcon}
                onclick={() => setCalenderOpen((prev) => ({ ...prev, end: true }))}
                isMoreClass={`!w-full !justify-start`}
                isDisabled={userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_create') ? false : true}
            />
        </div>
    ));

    const onSubmit = async (values: any, helpers: any) => {
        setBtnDisabled(true);
        let payload = {
            title: `${values.title}`,
            description: values.description ?? null,
            startDate: utcConverter(values.startDate, 'YYYY-MM-DD HH:mm:ss'),
            endDate: endDate ? utcConverter(values.endDate, 'YYYY-MM-DD HH:mm:ss') : null,
            status: values.status,
            assignedTo: values.assignedTo,
            empIds: values.employeeId || [],
            selectedItems: values.selectedItems,
            createdBy: userData?.id,
        };
        try {
            if (isUpdate) {
                const updatePayload = { ...payload, taskId: selectedRowData.id };
                const res = await taskUpdate(updatePayload);
                if (res.status === 200) {
                    isOnSuccess();
                    toaster('success', res.data.message);
                } else {
                    setError(res.data.message);
                    setBtnDisabled(false);
                }
            } else {
                const res = await createTask(payload);
                if (res.status === 200) {
                    isOnSuccess();
                    toaster('success', res.data.message);
                } else {
                    setError(res.data.message);
                    setBtnDisabled(false);
                }
            }
        } catch (err: any) {
            setError(err?.response.message);
            setBtnDisabled(false);
        }
    };

    const formik = useFormik({
        initialValues: getInitialValues(),
        enableReinitialize: true,
        validationSchema: Yup.object({
            title: Yup.string().required('Please enter title'),
            description: Yup.string().required('Please enter description'),
            startDate: Yup.string().required('Please enter start date'),
            assignedTo: Yup.array().of(Yup.string()).min(1, 'Please select assigned to'),
            status: Yup.string().required('Please select status'),
            employeeId: Yup.array().of(Yup.string()).min(0, 'Please select at least one employee'),
            selectedItems: Yup.array().of(Yup.string()),
        }),
        onSubmit: onSubmit,
    });

    useEffect(() => {
        if (isUpdate && selectedRowData?.empIds) {
            const ids = parseEmployeeIds(selectedRowData.empIds);
            const empids = parseEmployeeIds(selectedRowData.empList);
            if (ids.length > 0) {
                const selectedOptions = empids.map((id: any) => {
                    const emp = employeeListData.find((item: any) => item.employeeId === id.id || item.employeeId === Number(id.id));
                    if (emp) {
                        return {
                            value: emp.employeeId,
                            label: `${emp.name} ${emp.surname}`,
                            employeesData: employeeListData,
                        };
                    }
                    return { value: id.id, label: `${id.name} ${id.surname}` };
                });
                setSelectedEmployeeOption(selectedOptions);
            }
            formik.setFieldValue('employeeId', ids);
        }
    }, [isUpdate, selectedRowData?.empIds, employeeListData]);

    useEffect(() => {
        if (isUpdate && selectedRowData?.assignedTo) {
            const ids = parseAssignedToIds(selectedRowData.assignedTo);
            const selectedOptions = ids.map((id: any) => {
                const user = userListData.find((item: any) => item.value === id || item.value === Number(id));
                if (user) {
                    return { value: user.value, label: user.name };
                }
                return null;
            });
            setSelectedAssignedToOption(selectedOptions);
            formik.setFieldValue('assignedTo', ids);
        }
    }, [isUpdate, selectedRowData?.assignedTo, userListData]);

    return (
        <>
            <div className="p-8 mt-6 bg-white rounded-3xl">
                <div>
                    <div>
                        <p className="text-black text-base font-black">Adding new Task</p>
                        <p className="text-black text-sm font-medium leading-none mt-2">all the information bellow is required to add new task</p>
                    </div>
                    <form className="mt-4 gap-5">
                        <div className="flex flex-row gap-5 max-lg:flex-col">
                            <div className="flex flex-col gap-3">
                                <div className="flex flex-col md:flex-row gap-5 max-lg:w-full">
                                    <div className="md:w-1/2 lg:w-[230px] w-full">
                                        <InputBox
                                            name={'title'}
                                            type={'text'}
                                            className="bg-gray10 border-none"
                                            onChange={(e: any) => {
                                                formik.handleChange(e);
                                                setError('');
                                                setIsSaveValidation(false);
                                            }}
                                            // onBlur={formik.handleBlur}
                                            inputId={'title'}
                                            value={formik.values.title}
                                            placeholder="Enter Title"
                                            error={formik.touched.title && isSaveValidation ? (formik.errors.title as string) : ''}
                                            maxLength={validation.name}
                                            disabled={userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_create') ? false : true}
                                        />
                                    </div>
                                    <div className="md:w-1/2 lg:w-[230px] w-full voucher-date-range-picker-responsive">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(date: Date) => handleDateChange(date, 'start')}
                                            open={calenderOpen.start}
                                            onClickOutside={() => setCalenderOpen((prev) => ({ ...prev, start: false }))}
                                            customInput={<CustomStartInput />}
                                            showPopperArrow={false}
                                            calendarClassName="sort-custom-datepicker bg-black text-gray-100 !w-full"
                                            className="w-full"
                                        >
                                            <div className="inline-flex job-filter-btn pb-2">
                                                <IconWithButton title={dateTimeFormate(startDate, 'DD MMM, YYYY')} />
                                                <button type="button" className="ms-5" onClick={() => setCalenderOpen((prev) => ({ ...prev, start: false }))}>
                                                    <img src={closeIcon} className="w-6 h-6 rounded-full me-2" alt="close" />
                                                </button>
                                            </div>
                                        </DatePicker>
                                        {formik.touched.startDate && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.startDate as string}</p>}
                                        {dateError && <p className="text-red-600 text-sm mt-1">{dateError}</p>}
                                    </div>
                                    <div className="md:w-1/2 lg:w-[230px] w-full voucher-date-range-picker-responsive">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(date: Date) => handleDateChange(date, 'end')}
                                            open={calenderOpen.end}
                                            onClickOutside={() => setCalenderOpen((prev) => ({ ...prev, end: false }))}
                                            customInput={<CustomEndInput />}
                                            showPopperArrow={false}
                                            calendarClassName="sort-custom-datepicker bg-black text-gray-100 !w-full"
                                        >
                                            <div className="inline-flex job-filter-btn pb-2">
                                                <IconWithButton title={formik.values.endDate ? dateTimeFormate(endDate, 'DD MMM, YYYY') : 'End Date'} />
                                                <button type="button" className="ms-5" onClick={() => setCalenderOpen((prev) => ({ ...prev, end: false }))}>
                                                    <img src={closeIcon} className="w-6 h-6 me-2 rounded-full" alt="close" />
                                                </button>
                                            </div>
                                        </DatePicker>
                                    </div>
                                </div>
                                <div className="w-full">
                                    <div className="w-full">
                                        {' '}
                                        <AsyncSelect
                                            isMulti
                                            cacheOptions
                                            value={selectedAssignedToOption}
                                            loadOptions={getUserList}
                                            defaultOptions={true}
                                            placeholder="Select Assign To"
                                            className="text-sm font-medium w-full"
                                            classNames={{
                                                control: (state) => `bg-gray-100 border rounded-lg ${state.isFocused ? 'border-blue-500' : 'border-gray-300'} focus:outline-none`,
                                                menu: () => 'bg-white shadow-lg rounded-lg mt-1',
                                                menuList: () => 'max-h-60 overflow-auto',
                                                option: (state) => `px-4 py-2 cursor-pointer text-gray-900 ${state.isFocused ? 'bg-blue-50' : ''} ${state.isSelected ? 'bg-blue-500 text-white' : ''}`,
                                                placeholder: () => 'text-gray-500',
                                                singleValue: () => 'text-gray-900',
                                            }}
                                            isClearable
                                            menuPlacement="bottom"
                                            loadingMessage={() => 'Fetching users...'}
                                            noOptionsMessage={() => 'No users found'}
                                            onChange={handleAssignedToSelect}
                                            isDisabled={userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_create') ? false : true}
                                        />
                                        {formik.touched.assignedTo && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.assignedTo as string}</p>}
                                    </div>{' '}
                                </div>
                                <div className="w-full">
                                    <div className="w-full voucher-date-range-picker-responsive">
                                        <Dropdown
                                            value={formik.values.status}
                                            options={statusOptions}
                                            optionLabel="name"
                                            optionValue="value"
                                            placeholder="Select status"
                                            className="w-full border !h-[42px] !leading-[16px]"
                                            onChange={(e) => {
                                                formik.setFieldValue('status', e.value);
                                                setError('');
                                            }}
                                            onBlur={() => formik.setFieldTouched('status', true)}
                                            disabled={
                                                userData?.permissions?.includes('task_update') ||
                                                userData?.permissions?.includes('task_status_update') ||
                                                userData?.permissions?.includes('task_create')
                                                    ? false
                                                    : true
                                            }
                                        />
                                        {formik.touched.status && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.status as string}</p>}
                                    </div>
                                </div>
                                <div className="w-full">
                                    <textarea
                                        value={formik.values.description ?? ''}
                                        onChange={(e: any) => {
                                            formik.handleChange(e);
                                            setError('');
                                            setIsSaveValidation(false);
                                        }}
                                        rows={4}
                                        name="description"
                                        cols={50}
                                        className="h-16 w-full px-4 py-3 bg-zinc-100 rounded-xl mt-2 text-sm font-normal scrollbar-default"
                                        placeholder="Description"
                                        style={{ resize: 'none', outline: 'none' }}
                                        disabled={userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_create') ? false : true}
                                    />
                                    {formik.touched.description && isSaveValidation && <p className="text-red-600 mt-1 text-sm">{formik.errors.description as string}</p>}
                                </div>
                                <div className="w-full">
                                    <AsyncSelect
                                        isMulti
                                        cacheOptions
                                        value={selectedEmployeeOption}
                                        loadOptions={getEmployList}
                                        defaultOptions={true}
                                        placeholder="Search Employee"
                                        className="text-sm font-medium w-full lg:min-w-[340px]"
                                        isOptionDisabled={(option) => option.value === '__header__'}
                                        classNames={{
                                            control: (state) => `bg-gray-100 border rounded-lg ${state.isFocused ? 'border-blue-500' : 'border-gray-300'} focus:outline-none`,
                                            menu: () => 'bg-white shadow-lg rounded-lg mt-1',
                                            menuList: () => 'max-h-60 overflow-auto',
                                            option: (state) => `px-4 py-2 cursor-pointer text-gray-900 ${state.isFocused ? 'bg-blue-50' : ''} ${state.isSelected ? 'bg-blue-500 text-white' : ''}`,
                                            placeholder: () => 'text-gray-500',
                                            singleValue: () => 'text-gray-900',
                                        }}
                                        isClearable
                                        menuPlacement="bottom"
                                        loadingMessage={() => 'Fetching jobs...'}
                                        noOptionsMessage={() => 'No jobs found'}
                                        onChange={handleEmployeeSelect}
                                        isDisabled={userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_create') ? false : true}
                                    />
                                </div>
                            </div>
                        </div>

                        {error && <p className="text-red-600 mt-10 text-sm text-center">{error}</p>}
                    </form>
                </div>
            </div>
            <div className="hidden max-lg:block  pb-3 max-md:pt-5 max-lg:pt-[26px]">
                <ResponsiveTextWithIconButton title={'SAVE'} icon={rightIcon} isDisabled={btnDisabled} onclick={() => setIsSave(true)} />
            </div>
        </>
    );
};
export default AddNewTask;
